import {Stack} from '@cjdev-internal/visual-stack';
import {Text} from "@cjdev-internal/visual-stack-x/Text";
import * as appConstant from "../../constants/appConstant";
import React from "react";

const Dimensions = ({DateFilter}) =>
    <Stack gap="medium">
        <Text color="primary" size={13} weight="medium" className="margin-top-5">{appConstant.PLACEMENT_RUN_DATE}</Text>
        <DateFilter/>
    </Stack>;

export default Dimensions;